export const peptideData = [
  {
    id: 1,
    name: "5-Amino-1MQ",
    description: "NNMT inhibitor for metabolic health",
    link: "https://peptides.link/5-Amino-1MQ",
    tags: ["American Version"]
  },
  {
    id: 2,
    name: "Adrenact",
    originalName: "Glandokort",
    description: "Peptide bioregulator for adrenal gland function",
    link: "https://peptides.link/adrenact",
    tags: ["American Version", "Enhanced Formula", "Upgraded"]
  },
  {
    id: 3,
    name: "ANEMO 3 Plus",
    description: "Complex peptide formula",
    link: "https://peptides.link/anemo3plus",
    tags: ["American Version", "Enhanced Formula"]
  },
  {
    id: 4,
    name: "AOD-9604 and Fragment 176-191",
    description: "Fragment 176-191 for metabolic function",
    link: "https://peptides.link/AOD-9604",
    tags: ["American Version"]
  },
  {
    id: 5,
    name: "ARA-290",
    description: "Peptide for nerve function",
    link: "https://peptides.link/ARA-290",
    tags: ["American Version"]
  },
  {
    id: 6,
    name: "B7-33",
    description: "Relaxin-like peptide",
    link: "https://peptides.link/b7-33",
    tags: ["American Version"]
  },
  {
    id: 7,
    name: "Bonocore",
    originalName: "Bonomarlot",
    description: "Peptide bioregulator for bone tissue",
    link: "https://peptides.link/bonocore",
    tags: ["American Version", "Enhanced Formula", "Upgraded"]
  },
  {
    id: 8,
    name: "Bonomarlot",
    description: "Original peptide bioregulator for bone tissue",
    link: "https://peptides.link/bonomarlot",
    tags: ["Russian Version"]
  },
  {
    id: 9,
    name: "Bonothyrk",
    description: "Peptide bioregulator",
    link: "https://peptides.link/bonothyrk",
    tags: ["Russian Version"]
  },
  {
    id: 10,
    name: "BPC-157",
    description: "Body Protection Compound 157",
    link: "https://peptides.link/BPC-157",
    tags: ["Research Peptide"]
  },
  {
    id: 11,
    name: "Bronchogen",
    description: "Peptide bioregulator for bronchial function",
    link: "https://peptides.link/bronchogen",
    tags: ["Russian Version"]
  },
  {
    id: 12,
    name: "Cardiogen",
    description: "Peptide bioregulator for cardiovascular function",
    link: "https://peptides.link/cardiogen",
    tags: ["Russian Version"]
  },
  {
    id: 13,
    name: "Carnosine and Anserine",
    description: "Dipeptides with antioxidant properties",
    link: "https://peptides.link/anserinecarnosine",
    tags: ["Research Peptide"]
  },
  {
    id: 14,
    name: "Cartalax",
    description: "Peptide bioregulator for cartilage tissue",
    link: "https://peptides.link/cartalax",
    tags: ["Russian Version"]
  },
  {
    id: 15,
    name: "Cartalax",
    description: "Alternative source for cartilage peptide bioregulator",
    link: "https://peptides.link/cartalax2",
    tags: ["Russian Version"]
  },
  {
    id: 16,
    name: "Cartesyl",
    originalName: "Cartalax",
    description: "Peptide bioregulator for cartilage tissue",
    link: "https://peptides.link/cartesyl",
    tags: ["American Version", "Enhanced Formula", "Upgraded"]
  },
  {
    id: 17,
    name: "Cellex",
    description: "Peptide complex",
    link: "https://peptides.link/cellex",
    tags: ["Russian Version"]
  },
  {
    id: 18,
    name: "Cerebrolysin",
    description: "Neuropeptide preparation",
    link: "https://peptides.link/cerebrolysin",
    tags: ["Research Peptide"]
  },
  {
    id: 19,
    name: "Cerluten",
    description: "Peptide bioregulator for brain function",
    link: "https://peptides.link/cerluten",
    tags: ["Russian Version"]
  },
  {
    id: 20,
    name: "Chelohart",
    description: "Peptide bioregulator for heart function",
    link: "https://peptides.link/chelohart",
    tags: ["Russian Version"]
  },
  {
    id: 21,
    name: "Chitomur",
    description: "Peptide bioregulator for bladder function",
    link: "https://peptides.link/chitomur",
    tags: ["Russian Version"]
  },
  {
    id: 22,
    name: "Chonluten",
    description: "Peptide bioregulator for lung function",
    link: "https://peptides.link/chonluten",
    tags: ["Russian Version"]
  },
  {
    id: 23,
    name: "CJC-1295 NO DAC",
    description: "Growth hormone releasing hormone analogue",
    link: "https://peptides.link/CJC-1295",
    tags: ["Research Peptide"]
  },
  {
    id: 24,
    name: "Collacell",
    originalName: "Sigumir",
    description: "Peptide bioregulator for collagen production",
    link: "https://peptides.link/collacell",
    tags: ["American Version", "Enhanced Formula", "Upgraded"]
  },
  {
    id: 25,
    name: "Collagen Peptides",
    description: "Peptides derived from collagen protein",
    link: "https://peptides.link/collagen",
    tags: ["Research Peptide"]
  },
  {
    id: 26,
    name: "Cortagen",
    description: "Peptide bioregulator for cortical function",
    link: "https://peptides.link/cortagen",
    tags: ["Russian Version"]
  },
  {
    id: 27,
    name: "Cortexin",
    description: "Neuropeptide complex",
    link: "https://peptides.link/cortexin",
    tags: ["Russian Version"]
  },
  {
    id: 28,
    name: "Crystagen",
    description: "Peptide bioregulator for immune function",
    link: "https://peptides.link/crystagen",
    tags: ["Russian Version"]
  },
  {
    id: 29,
    name: "Cyclo (His-Pro)",
    description: "Cyclic dipeptide",
    link: "https://peptides.link/cyclo-his-pro",
    tags: ["Research Peptide"]
  },
  {
    id: 30,
    name: "Davunetide",
    description: "Neuroprotective peptide",
    link: "https://peptides.link/davunetide",
    tags: ["Research Peptide"]
  },
  {
    id: 31,
    name: "DSIP",
    description: "Delta sleep-inducing peptide",
    link: "https://peptides.link/dsip",
    tags: ["Research Peptide"]
  },
  {
    id: 32,
    name: "Endocron",
    description: "New Pituitary Gland Extract",
    link: "https://peptides.link/endocron",
    tags: ["American Version", "New"]
  },
  {
    id: 33,
    name: "Endoluten",
    description: "Peptide bioregulator for pineal gland function",
    link: "https://peptides.link/endoluten",
    tags: ["Russian Version"]
  },
  {
    id: 34,
    name: "Epitalon",
    description: "Peptide bioregulator for pineal gland function",
    link: "https://peptides.link/epitalon",
    tags: ["Research Peptide"]
  },
  {
    id: 35,
    name: "FOXO4-DRI",
    description: "Senolytic peptide",
    link: "https://peptides.link/foxo4-dri",
    tags: ["Research Peptide"]
  },
  {
    id: 36,
    name: "FSH",
    description: "Follicle-stimulating hormone",
    link: "https://peptides.link/fsh",
    tags: ["Research Peptide"]
  },
  {
    id: 37,
    name: "GASTRO 3 Plus",
    description: "Complex peptide formula for digestive function",
    link: "https://peptides.link/gastro3plus",
    tags: ["American Version", "Enhanced Formula"]
  },
  {
    id: 38,
    name: "Gastrogen",
    originalName: "Stamakort",
    description: "Peptide bioregulator for stomach function",
    link: "https://peptides.link/gastrogen",
    tags: ["American Version", "Enhanced Formula", "Upgraded"]
  },
  {
    id: 39,
    name: "GHK-Cu",
    description: "Copper peptide complex",
    link: "https://peptides.link/ghk-cu",
    tags: ["Research Peptide"]
  },
  {
    id: 40,
    name: "GHRP-2",
    description: "Growth hormone releasing peptide",
    link: "https://peptides.link/ghrp-2",
    tags: ["Research Peptide"]
  },
  {
    id: 41,
    name: "GHRP-6",
    description: "Growth hormone releasing peptide",
    link: "https://peptides.link/ghrp-6",
    tags: ["Research Peptide"]
  },
  {
    id: 42,
    name: "Glandokort",
    description: "Peptide bioregulator for adrenal gland function",
    link: "https://peptides.link/glandokort",
    tags: ["Russian Version"]
  },
  {
    id: 43,
    name: "Glutathione",
    description: "Injectable form of antioxidant tripeptide",
    link: "https://peptides.link/injectable-glutathione",
    tags: ["Research Peptide"]
  },
  {
    id: 44,
    name: "Glutathione",
    description: "Oral form of antioxidant tripeptide",
    link: "https://peptides.link/oral-glutathione",
    tags: ["Research Peptide"]
  },
  {
    id: 45,
    name: "Gotratix",
    description: "Peptide bioregulator",
    link: "https://peptides.link/gotratix",
    tags: ["Russian Version"]
  },
  {
    id: 46,
    name: "Humanin",
    description: "Mitochondrial-derived peptide",
    link: "https://peptides.link/humanin",
    tags: ["Research Peptide"]
  },
  {
    id: 47,
    name: "Ipamorelin",
    description: "Growth hormone secretagogue",
    link: "https://peptides.link/ipamorelin",
    tags: ["Research Peptide"]
  },
  {
    id: 48,
    name: "Kardium",
    originalName: "Chelohart",
    description: "Peptide bioregulator for heart function",
    link: "https://peptides.link/kardium",
    tags: ["American Version", "Enhanced Formula", "Upgraded"]
  },
  {
    id: 49,
    name: "Kartogenin (KGN)",
    description: "Small molecule for cartilage regeneration",
    link: "https://peptides.link/kgn",
    tags: ["Research Peptide"]
  },
  {
    id: 50,
    name: "Kisspeptin-1",
    description: "Reproductive hormone peptide",
    link: "https://peptides.link/kisspeptin-1",
    tags: ["Research Peptide"]
  },
  {
    id: 51,
    name: "LADY 3 Plus",
    description: "Complex peptide formula for women",
    link: "https://peptides.link/lady3plus",
    tags: ["American Version", "Enhanced Formula"]
  },
  {
    id: 52,
    name: "Libidon",
    description: "Peptide bioregulator for prostate function",
    link: "https://peptides.link/libidon",
    tags: ["Russian Version"]
  },
  {
    id: 53,
    name: "Livagen",
    description: "Peptide bioregulator for liver function",
    link: "https://peptides.link/livagen",
    tags: ["Russian Version"]
  },
  {
    id: 54,
    name: "Link N Terminal Peptide (LPP)",
    description: "Peptide for disc regeneration",
    link: "https://peptides.link/lpp",
    tags: ["Research Peptide"]
  },
  {
    id: 55,
    name: "LL-37",
    description: "Antimicrobial peptide",
    link: "https://peptides.link/LL-37",
    tags: ["Research Peptide"]
  },
  {
    id: 56,
    name: "Lungard",
    originalName: "Taxorest",
    description: "Peptide bioregulator for lung function",
    link: "https://peptides.link/lungard",
    tags: ["American Version", "Enhanced Formula", "Upgraded"]
  },
  {
    id: 57,
    name: "Matrixyl, Matrixyl synthe'6, Matrixyl3000",
    description: "Skin peptide complexes",
    link: "https://peptides.link/matrixyl",
    tags: ["Research Peptide"]
  },
  {
    id: 58,
    name: "Melanotan-1",
    description: "Alpha-melanocyte stimulating hormone analog",
    link: "https://peptides.link/melanotan-1",
    tags: ["Research Peptide"]
  },
  {
    id: 59,
    name: "Melanotan-2",
    description: "Alpha-melanocyte stimulating hormone analog",
    link: "https://peptides.link/melanotan-2",
    tags: ["Research Peptide"]
  },
  {
    id: 60,
    name: "MIF-1",
    description: "Melanocyte-stimulating hormone release-inhibiting factor",
    link: "https://peptides.link/mif-1",
    tags: ["Research Peptide"]
  },
  {
    id: 61,
    name: "MOTS-C",
    description: "Mitochondrial-derived peptide",
    link: "https://peptides.link/mots-c",
    tags: ["Research Peptide"]
  },
  {
    id: 62,
    name: "NEPHRO 3 Plus",
    description: "Complex peptide formula for kidney function",
    link: "https://peptides.link/nephro3plus",
    tags: ["American Version", "Enhanced Formula"]
  },
  {
    id: 63,
    name: "OSTEO 3 Plus",
    description: "Complex peptide formula for bone health",
    link: "https://peptides.link/osteo3plus",
    tags: ["American Version", "Enhanced Formula"]
  },
  {
    id: 64,
    name: "Ovagen",
    description: "Peptide bioregulator for ovarian function",
    link: "https://peptides.link/ovagen",
    tags: ["Russian Version"]
  },
  {
    id: 65,
    name: "Ovalis",
    originalName: "Zhenoluten",
    description: "Peptide bioregulator for ovarian function",
    link: "https://peptides.link/ovalis",
    tags: ["American Version", "Enhanced Formula", "Upgraded"]
  },
  {
    id: 66,
    name: "Pancragen",
    description: "Peptide bioregulator for pancreatic function",
    link: "https://peptides.link/pancragen",
    tags: ["Russian Version"]
  },
  {
    id: 67,
    name: "PAT (Peptide Analogue of Thymalin)",
    description: "Synthetic thymic peptide",
    link: "https://peptides.link/pat",
    tags: ["Research Peptide"]
  },
  {
    id: 68,
    name: "PEPITEM",
    description: "Immunomodulatory peptide",
    link: "https://peptides.link/PEPITEM",
    tags: ["Research Peptide"]
  },
  {
    id: 69,
    name: "Pielotax",
    description: "Peptide bioregulator for kidney function",
    link: "https://peptides.link/pielotax",
    tags: ["Russian Version"]
  },
  {
    id: 70,
    name: "Pinealon",
    description: "Neuroprotective peptide",
    link: "https://peptides.link/pinealon",
    tags: ["Russian Version"]
  },
  {
    id: 71,
    name: "Pinealon",
    description: "Alternative source for neuroprotective peptide",
    link: "https://peptides.link/pinealon2",
    tags: ["Russian Version"]
  },
  {
    id: 72,
    name: "Pinealon",
    description: "Powder form of neuroprotective peptide",
    link: "https://peptides.link/pinealonpowder",
    tags: ["Russian Version"]
  },
  {
    id: 73,
    name: "Pineamin",
    description: "Peptide bioregulator for pineal gland function",
    link: "https://peptides.link/pineamin",
    tags: ["Russian Version"]
  },
  {
    id: 74,
    name: "POLO 3 Plus",
    description: "Complex peptide formula for men",
    link: "https://peptides.link/polo3plus",
    tags: ["American Version", "Enhanced Formula"]
  },
  {
    id: 75,
    name: "Prostatilen",
    description: "Peptide bioregulator for prostate function",
    link: "https://peptides.link/prostatilen",
    tags: ["Russian Version"]
  },
  {
    id: 76,
    name: "Prostalon",
    originalName: "Libidon",
    description: "Peptide bioregulator for prostate function",
    link: "https://peptides.link/prostalon",
    tags: ["American Version", "Enhanced Formula", "Upgraded"]
  },
  {
    id: 77,
    name: "Prostamax",
    description: "Peptide bioregulator for prostate function",
    link: "https://peptides.link/prostamax",
    tags: ["Russian Version"]
  },
  {
    id: 78,
    name: "PROTECTOR 3 Plus",
    description: "Complex peptide formula for immune function",
    link: "https://peptides.link/protector3plus",
    tags: ["American Version", "Enhanced Formula"]
  },
  {
    id: 79,
    name: "PT-141",
    description: "Bremelanotide, melanocortin receptor agonist",
    link: "https://peptides.link/pt-141",
    tags: ["Research Peptide"]
  },
  {
    id: 80,
    name: "Renolux",
    originalName: "Pielotax",
    description: "Peptide bioregulator for kidney function",
    link: "https://peptides.link/renolux",
    tags: ["American Version", "Enhanced Formula", "Upgraded"]
  },
  {
    id: 81,
    name: "RESPIRO 3 Plus",
    description: "Complex peptide formula for respiratory function",
    link: "https://peptides.link/respiro3plus",
    tags: ["American Version", "Enhanced Formula"]
  },
  {
    id: 82,
    name: "Retatrutide",
    description: "GLP-1/GIP/glucagon receptor agonist",
    link: "https://peptides.link/retatrutide",
    tags: ["Research Peptide"]
  },
  {
    id: 83,
    name: "Selank",
    description: "Anxiolytic peptide",
    link: "https://peptides.link/selank",
    tags: ["Russian Version"]
  },
  {
    id: 84,
    name: "Semaglutide",
    description: "GLP-1 receptor agonist",
    link: "https://peptides.link/semaglutide",
    tags: ["Research Peptide"]
  },
  {
    id: 85,
    name: "Semax",
    description: "Nootropic peptide",
    link: "https://peptides.link/semax",
    tags: ["Russian Version"]
  },
  {
    id: 86,
    name: "Sermorelin",
    description: "Growth hormone releasing hormone analog",
    link: "https://peptides.link/sermorelin",
    tags: ["Research Peptide"]
  },
  {
    id: 87,
    name: "Sigumir",
    description: "Peptide bioregulator for joint and cartilage function",
    link: "https://peptides.link/sigumir",
    tags: ["Russian Version"]
  },
  {
    id: 88,
    name: "Slavinorm",
    description: "Peptide bioregulator",
    link: "https://peptides.link/slavinorm",
    tags: ["Russian Version"]
  },
  {
    id: 89,
    name: "SS-31",
    description: "Mitochondrial-targeting peptide",
    link: "https://peptides.link/ss-31",
    tags: ["Research Peptide"]
  },
  {
    id: 90,
    name: "Stamakort",
    description: "Peptide bioregulator for stomach function",
    link: "https://peptides.link/stamakort",
    tags: ["Russian Version"]
  },
  {
    id: 91,
    name: "Suprefort",
    description: "Peptide bioregulator for pancreatic function",
    link: "https://peptides.link/suprefort",
    tags: ["Russian Version"]
  },
  {
    id: 92,
    name: "Superlymph",
    description: "Peptide bioregulator for lymphatic function",
    link: "https://peptides.link/superlymph",
    tags: ["Russian Version"]
  },
  {
    id: 93,
    name: "Svetinorm",
    description: "Peptide bioregulator for liver function",
    link: "https://peptides.link/svetinorm",
    tags: ["Russian Version"]
  },
  {
    id: 94,
    name: "Taxorest",
    description: "Peptide bioregulator for lung function",
    link: "https://peptides.link/taxorest",
    tags: ["Russian Version"]
  },
  {
    id: 95,
    name: "Testoluten",
    description: "Peptide bioregulator for testicular function",
    link: "https://peptides.link/testoluten",
    tags: ["Russian Version"]
  },
  {
    id: 96,
    name: "Testovive",
    originalName: "Testoluten",
    description: "Peptide bioregulator for testicular function",
    link: "https://peptides.link/testovive",
    tags: ["American Version", "Enhanced Formula", "Upgraded"]
  },
  {
    id: 97,
    name: "Thymalin",
    description: "Peptide bioregulator for thymus function",
    link: "https://peptides.link/thymalin",
    tags: ["Russian Version"]
  },
  {
    id: 98,
    name: "Thymogen",
    description: "Synthetic dipeptide with immunomodulatory properties",
    link: "https://peptides.link/thymogen",
    tags: ["Russian Version"]
  },
  {
    id: 99,
    name: "Thymosin Alpha-1",
    description: "Immune system peptide",
    link: "https://peptides.link/thymosinalpha1",
    tags: ["Research Peptide"]
  },
  {
    id: 100,
    name: "Thymosin Beta-4",
    description: "Tissue repair peptide",
    link: "https://peptides.link/thymosinbeta4",
    tags: ["Research Peptide"]
  },
  {
    id: 101,
    name: "Thymulin",
    description: "Thymic hormone",
    link: "https://peptides.link/thymulin",
    tags: ["Research Peptide"]
  },
  {
    id: 102,
    name: "Thymusol",
    originalName: "Vladonix & Thymalin",
    description: "Peptide bioregulator for thymus function",
    link: "https://peptides.link/thymusol",
    tags: ["American Version", "Enhanced Formula", "Upgraded"]
  },
  {
    id: 103,
    name: "Thyreogen",
    description: "Peptide bioregulator for thyroid function",
    link: "https://peptides.link/thyreogen",
    tags: ["Russian Version"]
  },
  {
    id: 104,
    name: "Thyrix",
    originalName: "Thyreogen",
    description: "Peptide bioregulator for thyroid function",
    link: "https://peptides.link/thyrix",
    tags: ["American Version", "Enhanced Formula", "Upgraded"]
  },
  {
    id: 105,
    name: "Tirzepatide",
    description: "GIP/GLP-1 receptor agonist",
    link: "https://peptides.link/tirzepatide",
    tags: ["Research Peptide"]
  },
  {
    id: 106,
    name: "Ventfort",
    description: "Peptide bioregulator for blood vessel function",
    link: "https://peptides.link/ventfort",
    tags: ["Russian Version"]
  },
  {
    id: 107,
    name: "Vesugen",
    description: "Peptide bioregulator for vascular function",
    link: "https://peptides.link/vesugen",
    tags: ["Russian Version"]
  },
  {
    id: 108,
    name: "Vesugen",
    description: "Alternative source for vascular peptide bioregulator",
    link: "https://peptides.link/vesugen2",
    tags: ["Russian Version"]
  },
  {
    id: 109,
    name: "Vesusten",
    description: "Peptide bioregulator for vessel function",
    link: "https://peptides.link/vesusten",
    tags: ["Russian Version"]
  },
  {
    id: 110,
    name: "Vilon",
    description: "Synthetic dipeptide with immunomodulatory properties",
    link: "https://peptides.link/vilon",
    tags: ["Russian Version"]
  },
  {
    id: 111,
    name: "VISION 3 Plus",
    description: "Complex peptide formula for eye health",
    link: "https://peptides.link/vision3plus",
    tags: ["American Version", "Enhanced Formula"]
  },
  {
    id: 112,
    name: "Visoluten",
    description: "Peptide bioregulator for retinal function",
    link: "https://peptides.link/visoluten",
    tags: ["Russian Version"]
  },
  {
    id: 113,
    name: "Vladonix",
    description: "Peptide bioregulator for thymus function",
    link: "https://peptides.link/thymalin",
    tags: ["Russian Version"]
  },
  {
    id: 114,
    name: "Zhenoluten",
    description: "Peptide bioregulator for ovarian function",
    link: "https://peptides.link/zhenoluten",
    tags: ["Russian Version"]
  }
];